module.exports = __webpack_public_path__ + "img/arrow_right_circle.5e37e4b6.svg";